import { getEntityFromScope } from '@bingads-webui/edm-campaign';

export const fetchUetTags = ({
  count,
  ids,
  onFailure,
  onSuccess,
  scope,
}) => {
  const { currentAccount } = getEntityFromScope(scope);
  const currentAccountTagsObservable = currentAccount.Tags.get({
    top: count,
    select: [
      'Id',
      'Name',
      'Status',
      'GoalsCount',
    ],
    orderby: [
      ['GoalsCount', 'desc'],
    ],
    filter: {
      where: ids
        ? `Status eq 'Active' AND Id in [${ids.join(', ')}]`
        : 'Status eq \'Active\'',
    },
  });

  return currentAccountTagsObservable.subscribe({
    next: onSuccess,
    error: onFailure,
  });
};

export const transformFetchedUetTag = fetchedTag => ({
  id: fetchedTag.Id,
  name: fetchedTag.Name,
  status: fetchedTag.Status,
  goals: [],
  goalsCount: fetchedTag.GoalsCount,
});

export const getFetchedTagCollections = (data) => {
  const fetchedTags = {};
  const fetchedTagsAsArray = [];

  data.value.forEach((fetchedTag) => {
    const uetTag = transformFetchedUetTag(fetchedTag);
    fetchedTagsAsArray.push(uetTag);
    fetchedTags[fetchedTag.Id] = uetTag;
  });

  return {
    fetchedTags,
    fetchedTagsAsArray,
  };
};

export const getFetchedTagsWithGoalsIds = fetchedTags => fetchedTags
  .filter(fetchedTag => fetchedTag.goalsCount > 0)
  .map(fetchedTag => fetchedTag.id);
